import { create } from "zustand";
import { devtools } from "zustand/middleware";

import type { Section } from "~/providers/section-provider";

interface SectionStoreState {
  selectedSection?: Section;
  setSelectedSection: (section?: Section) => void;
  sectionDialogOpen: boolean;
  setSectionDialogOpen: (open: boolean) => void;
}

export const useSectionStore = create<SectionStoreState>()(
  devtools((set) => ({
    sectionDialogOpen: false,
    setSectionDialogOpen: (open) => {
      set(() => ({ sectionDialogOpen: open }));
    },
    setSelectedSection: (button) => {
      set(() => ({ selectedSection: button }));
    },
  })),
);
